import AxiosConfig from '../../../config/AxiosConfig';

const useCreateDecomposition = () => {
  const createDecomposition = async ({
    reference,
    quantity,
    origin,
    createdBy,
  }) => {
    try {
      const response = await AxiosConfig.create('post', `/createdecomposition/`)
        .call({ reference, quantity, origin, created_by: createdBy })
        .getResponseData();
      return response;
    } catch (error) {
      const errorMessage = error?.response?.data?.error || error.message;
      throw new Error(errorMessage);
    }
  };

  return { createDecomposition };
};

export default useCreateDecomposition;
